import { Component, OnInit } from '@angular/core';
import { ThemeGetModel } from 'src/app/core/models/user-management/get-theme-details-model';
import { ThemeModel } from 'src/app/core/models/user-management/theme-model';
import { UserManagementService } from 'src/app/core/services/user-management/user-management.service';

@Component({
  selector: 'app-theme-settings',
  templateUrl: './theme-settings.component.html',
  styleUrls: ['./theme-settings.component.scss']
})
export class ThemeSettingsComponent implements OnInit {
  selectedTheme: ThemeModel = new ThemeModel();
  selectedFile: File | null = null;
  themeDetails!: ThemeGetModel;
  isDefault = false;
  isDefaultTheme = false;
  isUploadLoader = false;
  isResetLoader = false;
  constructor(private userService: UserManagementService) {

  }
  ngOnInit(): void {
    this.userService.getThemeDetails().subscribe(
      (data: ThemeGetModel) => {
        this.themeDetails = data;
        this.selectedTheme.color = this.themeDetails.color;
        if(this.selectedTheme.color == "#4a1c9499"){
          this.isDefaultTheme = true;
        }
      });
  }
  changeTheme() {
    this.isUploadLoader = true;
    if (!this.selectedTheme.image || !this.selectedTheme.banner) {
      return;
    }
    const formData = new FormData();
    formData.append('image', this.selectedTheme.image, this.selectedTheme.image.name);
    formData.append('banner', this.selectedTheme.banner, this.selectedTheme.banner.name);
    formData.append('color', this.selectedTheme.color);
    localStorage.removeItem('imageSrc');
    localStorage.removeItem('bannerSrc'); 
    localStorage.removeItem('themeColor');
    this.userService.addTheme(formData, this.isDefault).subscribe((res: any) => {
    });
    
    setTimeout(() => {
      window.location.reload();
    }, 2000);
    // this.isUploadLoader = false;
  }
  onFileSelected(event: any) {
    this.selectedTheme.image = event.target.files[0];
  }
  onBannerSelected(event: any) {
    this.selectedTheme.banner = event.target.files[0];
  }
  resetTheme(){
    this.isResetLoader = true;
    const formData = new FormData();
    this.isDefault = true;
    localStorage.removeItem('imageSrc');
    localStorage.removeItem('bannerSrc'); 
    localStorage.removeItem('themeColor');
    this.userService.addTheme(formData, this.isDefault).subscribe((res: any) => {
      this.isDefault = false;
    });
    setTimeout(() => {
      window.location.reload();
    }, 2000);
  }
}
